/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators';
import FORM from 'common/consts/form';
import OkIcon from './OkIcon';
import NotIcon from './NotIcon';
import CustomField from './CustomField';
import CustomInput from './CustomInput';
import CustomLabel from './CustomLabel';
import UnderlineDots from './UnderlineDots';
import RequiredIndicator from './RequiredIndicator';
import CustomTextArea from './CustomTextArea';

class CustomFormElement extends Component {
  constructor(props) {
    super(props);

    this.validateOnInput = props.validateOnInput;

    this.state = {
      pristine: true,
      correct: true,
      touched: false,
      empty: true,
      value: '',
      textAreaRows: 1,
    };

    this.inputRef = React.createRef();
    this.customFieldRef = React.createRef();
    this.underlineDotsRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { resetValue } = this.props;

    if (prevProps.resetValue !== resetValue) {
      this.setState({
        pristine: true,
        correct: true,
        touched: false,
        empty: true,
        value: '',
      });
    }
  }

  @Bind
  onInput(inputEvent) {
    const {
      onInput,
    } = this.props;

    this.setState({
      pristine: false,
      empty: inputEvent.target.value === '',
    });

    if (this.validateOnInput) {
      this.setValidationState();
    }

    this.setState({
      value: inputEvent.target.value,
    });

    onInput(inputEvent.target.value);
  }

  @Bind
  onBlur(blurEvent) {
    const { target } = blurEvent;
    const { value } = target;

    this.setState({ touched: true });

    if (!this.validateOnInput) {
      this.setValidationState();
    }
    const { name, getValue } = this.props;

    getValue({
      inputName: name,
      value,
    });
  }

  @Bind
  setValidationState() {
    this.setState({ correct: this.inputRef.current.checkValidity() });
  }

  @Bind
  autoSize() {
    const el = this.inputRef.current;
    setTimeout(() => {
      el.style.cssText = 'height: auto; padding: 0';
      el.style.cssText = `height:${el.scrollHeight}px`;
      this.setState({
        textAreaRows: Math.floor(el.scrollHeight / FORM.DESKTOP_TEXT_AREA_LINE_HEIGHT),
      });
    }, 0);
  }

  @Bind
  generateUnderlineDots() {
    const {
      textAreaRows,
    } = this.state;
    return (
      [...Array(textAreaRows).keys()].map(rowNumber => (
        <UnderlineDots
          key={rowNumber}
          innerRef={this.underlineDotsRef}
          offset={rowNumber !== 0 ? rowNumber * FORM.DESKTOP_TEXT_AREA_LINE_HEIGHT : null}
        />
      ))
    );
  }

  render() {
    const {
      pristine,
      touched,
      correct,
      empty,
      value,
    } = this.state;

    const {
      type,
      name,
      labelName,
      required,
      minlength,
      maxlength,
      pattern,
      title,
    } = this.props;

    const doValidate = (!pristine && this.validateOnInput) || (touched && !this.validateOnInput);

    return (
      <CustomField innerRef={this.customFieldRef}>
        {type === 'textarea'
          ? (
            <CustomTextArea
              innerRef={this.inputRef}
              type={type}
              name={name}
              required={required}
              minlength={minlength}
              maxlength={maxlength}
              pattern={pattern}
              title={title}
              onChange={this.onInput}
              onBlur={this.onBlur}
              isEmpty={empty}
              value={value}
              onKeyDown={this.autoSize}
            />
          ) : (
            <CustomInput
              innerRef={this.inputRef}
              type={type}
              name={name}
              required={required}
              minlength={minlength}
              maxlength={maxlength}
              pattern={pattern}
              title={title}
              onChange={this.onInput}
              onBlur={this.onBlur}
              isEmpty={empty}
              value={value}
            />
          )}

        <CustomLabel htmlFor={name}>
          {labelName}
          {required ? <RequiredIndicator /> : ''}
        </CustomLabel>

        {type === 'textarea' ? this.generateUnderlineDots() : (
          <UnderlineDots innerRef={this.underlineDotsRef} />
        )}

        {doValidate && (correct ? <OkIcon /> : <NotIcon />)}
      </CustomField>
    );
  }
}
CustomFormElement.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  labelName: PropTypes.string,
  required: PropTypes.bool,
  validateOnInput: PropTypes.bool,
  minlength: PropTypes.number,
  maxlength: PropTypes.number,
  pattern: PropTypes.string,
  title: PropTypes.string,
  getValue: PropTypes.func.isRequired,
  resetValue: PropTypes.bool,
  onInput: PropTypes.func,
};
CustomFormElement.defaultProps = {
  type: '',
  labelName: '',
  required: false,
  validateOnInput: false,
  minlength: null,
  maxlength: null,
  pattern: null,
  title: null,
  resetValue: false,
  onInput: () => {},
};

export default CustomFormElement;



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomFormElement.jsx